enum CsvHeadersEnum {
  Email = 'email',
  Name = 'name',
}

export default CsvHeadersEnum;
